import { createAppSlice } from '../../app/createAppSlice'

const initialState = {
    foiFocus: ""
};

const foiOfFocusSlice = createAppSlice({
    name: "foiOfFocus",
    initialState,
    reducers: create => ({
        changeFoiFocus: create.reducer((state, action) => {
            state.foiFocus = action.payload
        }),
    }),
    selectors: {
        selectFoiFocus: foiOfFocus => foiOfFocus.foiFocus,
    },
})

export const {changeFoiFocus } = foiOfFocusSlice.actions

export const { selectFoiFocus } = foiOfFocusSlice.selectors

export default foiOfFocusSlice